module.exports = __webpack_public_path__ + "media/101.5ecc8297.mp3";